<div mat-dialog-content>
    <div style="text-align: center">
        <h3>{{ title }}</h3>
        @for (path of imagePaths; track path) {
            <img mat-card-image [src]="path" alt="picture preview" style="width: auto; max-width: 40%; height: auto; max-height: 100px; margin: 0px 5%; padding: 10px" />
        }
    </div>
</div>
<div mat-dialog-actions fxLayout="row" fxFlexFill>
    <button fxFlex mat-raised-button color="warn" (click)="onNoClick()">
        {{ "GENERAL.close" | translate }}
    </button>
</div>
